import React, { useState, useEffect } from 'react';

const ExperienceSelect = ({ voucherData, sessionToken, onBack, onSelected }) => {
    const [experiences, setExperiences] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [selectedId, setSelectedId] = useState('');

    useEffect(() => {
        const fetchExperiences = async () => {
            try {
                // Mock delay
                await new Promise(res => setTimeout(res, 600));
                // MOCK DATA based on voucher product
                setExperiences([
                    {
                        id: 101,
                        title: `${voucherData.product_name} - Coastal Retreat`,
                        description: 'A relaxing day at the coast with inclusive lunch.',
                        image: 'https://placehold.co/600x400/eeeeee/999999?text=Image',
                    },
                    {
                        id: 102,
                        title: `${voucherData.product_name} - Mountain Adventure`,
                        description: 'Exciting hiking trails with an experienced guide.',
                        image: 'https://placehold.co/600x400/eeeeee/999999?text=Image',
                    },
                    {
                        id: 103,
                        title: `${voucherData.product_name} - Spa Indulgence`,
                        description: 'Full day access to premium spa facilities.',
                        image: 'https://placehold.co/600x400/eeeeee/999999?text=Image',
                    },
                ]);
            } catch (err) {
                setError('Failed to load experiences. Please try again.');
            } finally {
                setLoading(false);
            }
        };
        fetchExperiences();
    }, [voucherData]);

    if (loading) {
        return (
            <div className="rll-spinner-wrap">
                <div className="rll-spinner" />
                <p>Loading available experiences...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ textAlign: 'center', padding: '2rem 0' }}>
                <div className="rll-alert rll-alert--error">{error}</div>
                <button onClick={onBack} className="rll-btn rll-btn--link">Go Back</button>
            </div>
        );
    }

    return (
        <div className="rll-animate-in">
            <div className="rll-section-header">
                <div>
                    <h3>Select an Experience</h3>
                    <p>Your voucher allows you to choose one of the following.</p>
                </div>
                <button onClick={onBack} className="rll-back-btn" aria-label="Go back">
                    <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                </button>
            </div>

            <div className="rll-experience-grid">
                {experiences.map((exp) => (
                    <div
                        key={exp.id}
                        className={`rll-experience-card ${selectedId === exp.id ? 'selected' : ''}`}
                        onClick={() => setSelectedId(exp.id)}
                    >
                        <img src={exp.image} alt={exp.title} />
                        <div className="rll-experience-card-body">
                            <h4>{exp.title}</h4>
                            <p>{exp.description}</p>
                        </div>

                        {selectedId === exp.id && (
                            <div className="rll-experience-check">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <div style={{ borderTop: '1px solid var(--rll-gray-200)', paddingTop: '1.5rem' }}>
                <button
                    onClick={() => onSelected(selectedId)}
                    disabled={!selectedId}
                    className="rll-btn rll-btn--primary"
                >
                    Continue with Selected
                </button>
            </div>
        </div>
    );
};

export default ExperienceSelect;
